module.exports = __webpack_public_path__ + "img/equipment.8930683b.png";